import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { HostingTypeToQueryParam } from '@atlassian/mpac-types';
import { tryParseJSON } from '@atlassian/mpac-utils';
import { stringify } from 'query-string';
import { useEffect } from 'react';
import { AppListingTab } from "../../../../../constants";
export const SORT_OPTIONS = {
  RECENT: 'recent',
  HELPFUL: 'helpful'
};
export const VOTE = {
  YES: 'yes',
  NO: 'no'
};
export const REVIEWS_STATUS = {
  LOADING_INITIAL: 'loadingInitial',
  SUCCESS: 'success',
  REJECTED: 'rejected',
  LOADING_MORE: 'loadingMore'
};
export const REVIEWS_ACTIONS = {
  SUCCESS: 'success',
  REJECTED: 'rejected',
  LOAD_MORE: 'loadMore',
  SORT: 'sort',
  DELETE: 'delete',
  POST: 'post',
  REFETCH: 'refetch',
  DELETE_VENDOR_RESPONSE: 'deleteVendorResponse',
  SET_HOSTING_TYPE: 'setHostingType'
};
export const makeReviewsTabLink = ({
  appListingLink,
  hosting,
  appId,
  slug
}) => {
  const baseUrl = appListingLink.expand({
    appId,
    slug,
    hosting: HostingTypeToQueryParam[hosting],
    tab: AppListingTab.Reviews
  });
  const searchParams = new URLSearchParams(window.location.search);
  const reviewId = searchParams.get('reviewId');
  const vote = searchParams.get('vote');
  const additionalQueryParams = _objectSpread({
    embeddedTab: 'true'
  }, reviewId && vote && {
    reviewId,
    vote
  });
  return [baseUrl, stringify(additionalQueryParams)].join('&');
};
const hasAccessToIframe = iframe => {
  try {
    const _ = iframe.contentWindow.location.origin;
    return true;
  } catch (_unused) {
    return false;
  }
};
/**
 * The review iframe still lives in AMKT, and emits various events
 * to its parent frame when loaded in an embedded iframe.
 * These events can be used to detect load, pagination etc
 */export const useReviewIframeEvents = (iframeRef, reviewsLink) => {
  let onIframeLoadStartedCallback = _ => {};
  let onIframeInitializedCallback = _ => {};
  let onMoreReviewsRenderedCallback = _ => {};
  let onIframeCORSErrorCallback = _ => {};
  const onIframeInitialized = callback => {
    onIframeInitializedCallback = callback;
  };
  const onMoreReviewsRendered = callback => {
    onMoreReviewsRenderedCallback = callback;
  };
  const onIframeLoadStarted = callback => {
    onIframeLoadStartedCallback = callback;
  };
  const onIframeCORSError = callback => {
    onIframeCORSErrorCallback = callback;
  };
  useEffect(() => {
    const {
      current: iframe
    } = iframeRef;
    if (!iframe) {
      return;
    }
    onIframeLoadStartedCallback(iframe);
    const listenToIframeEvents = ({
      origin,
      data
    }) => {
      if (!hasAccessToIframe(iframe)) {
        onIframeCORSErrorCallback();
        return;
      }

      // Only listen to message originating from the review's iframe
      if (!iframe.contentWindow.location.origin === origin) return;
      const eventParsedAsJSON = tryParseJSON(data);

      // Not all events are JSON — we ignore non JSON
      if (!eventParsedAsJSON.success) return;
      const parsedMessage = eventParsedAsJSON.result;

      // Ignore if the event payload doesn't match known signature
      if (!parsedMessage.type === 'app-listing-review-tab-event') {
        return;
      }
      switch (parsedMessage.message) {
        case 'initialized':
          onIframeInitializedCallback(iframe);
          break;
        case 'moreReviewsRendered':
          onMoreReviewsRenderedCallback(iframe);
          break;
      }
    };
    window.addEventListener('message', listenToIframeEvents, false);
    return () => {
      window.removeEventListener('message', listenToIframeEvents, false);
    };
  }, [reviewsLink]);
  return {
    onIframeLoadStarted,
    onIframeInitialized,
    onMoreReviewsRendered,
    onIframeCORSError
  };
};